module.exports = __webpack_public_path__ + "static/img/gsjsbj-Dgjxi0Nf.8cf599d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/gsjsbj-Dgjxi0Nf.png
// module id = i1kn
// module chunks = 16